import { axiosInstance } from "../axiosInstance";
import {
  DeleteNotificationTypeRequest,
  DeleteNotificationTypeResponse,
} from "./types";

export const deleteNotificationType = async (
  requestData: DeleteNotificationTypeRequest,
): Promise<DeleteNotificationTypeResponse> => {
  const { id } = requestData;

  const response = await axiosInstance.delete<DeleteNotificationTypeResponse>(
    `/api/private/notification-types/${id}`,
  );
  return response.data;
};
